import { createSlice } from "@reduxjs/toolkit";

const initialGeneralStore = {
  showAddClassRequest: false,
  classRequestId: "",
  cloneDetails: [],
  classRequestCreated: false,
  classRequestName: "",
  programName: "",
  classRequestNumbers: "",
  projectName: "",
  showProject: false,
  traineeSearch: false,
  siteLocation: "",
  parentClinetProject: "",
  activeTrainees: 0,
  loadingState: false,
  displayNewReleaseNotesUpto: null,
};

const generalStoreSlice = createSlice({
  name: "generalStore",
  initialState: initialGeneralStore,
  reducers: {
    updateShowProject(state, action) {
      state.showProject = action.payload;
    },
    updateClassRequestButton(state, action) {
      state.showAddClassRequest = action.payload;
    },
    updateCloneRequestDetails(state, action) {
      state.cloneDetails = action.payload;
    },
    updateClassRequestId(state, action) {
      state.classRequestId = action.payload;
    },

    updateClassRequestCreated(state, action) {
      state.classRequestCreated = action.payload;
    },
    resetCloneDetails(state) {
      state.cloneDetails = "";
    },
    updateClassRequestName(state, action) {
      state.classRequestName = action.payload;
    },
    updateProgramName(state, action) {
      state.programName = action.payload;
    },
    updateClassRequestNumbers(state, action) {
      state.classRequestNumbers = action.payload;
    },
    updateProjectName(state, action) {
      state.projectName = action.payload;
    },
    traineeSearch(state, action) {
      state.traineeSearch = action.payload;
    },
    updateSiteLocation(state, action) {
      state.siteLocation = action.payload;
    },
    updateParentClientProject(state, action) {
      state.parentClinetProject = action.payload;
    },
    activeTrainees(state, action) {
      state.activeTrainees = action.payload ? action.payload : 0;
    },
    loadingState(state, action) {
      state.loadingState = action.payload;
    },
    setDisplayNewReleaseUpto(state, action) {
      state.displayNewReleaseNotesUpto = action.payload;
    },
  },
});

export const generalStoreActions = generalStoreSlice.actions;

export default generalStoreSlice.reducer;
